const lang = document.documentElement.lang;

const days =
  lang === 'de'
    ? ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
    : ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const today = lang === 'de' ? 'Heute' : 'today';
const clear = lang === 'de' ? 'Zurücksetzen' : 'clear';
const close = lang === 'de' ? 'schließen' : 'close';
const months =
  lang === 'de'
    ? [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ]
    : [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];

export const datePickerConfig = {
  days,
  months,
  today,
  clear,
  close,
};

export const dateFormat = date => {
  const locales = lang === 'de' ? 'de-DE' : 'en-US';

  return date.toLocaleDateString(locales, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};
